import { faArrowLeft, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { toast } from 'react-toastify';
import { basePerformError } from '../../../helpers/error-helpers';
import { Popup } from './popup';
import { MultiError } from '../../../types/multi-error';

interface IProps extends RouteComponentProps {
    title: string | React.ReactElement,
    question: string | React.ReactElement,
    actionText?: string,
    successText?: string,
    onClose(): void,
    onAction(): any,
    onFinish?: any,
}

function ActionPopup(props: IProps) {
    return (
        <Popup
            modal={true}
            className="red"
            title={props.title}
            onClose={props.onClose}
            buttons={[
                {
                    title: <><FontAwesomeIcon icon={faArrowLeft} /> <span>Cancel</span></>,
                    className: 'gray',
                    onClick: props.onClose,
                },
                {
                    title: <><span>{props.actionText ? props.actionText : 'Ok'}</span> <FontAwesomeIcon icon={faThumbsUp} /></>,
                    className: 'red',
                    onClick: async () => {
                        try {
                            await props.onAction();
                            if(props.onFinish)
                                props.onFinish();
                            if(props.successText && props.successText.length)
                                toast.success(props.successText || 'Action has been successfully performed');
                            props.onClose();
                        }
                        catch(err) {
                            basePerformError(err as MultiError, props.history);
                        }
                    },
                },
            ]}
        >
            {props.question}
        </Popup>
    );
}


const ActionPopupWithHistory = withRouter(ActionPopup);

export { ActionPopupWithHistory as ActionPopup };
